<template>
	<div>
		<section class="section-title-page container-fluid" style="background-image: url('resources/img/example.jpg')">
			<div class="container">
				<div class="wrapper">
					<h1>Noticias <small style="font-weight: 300">a tu disposición</small></h1>
					<span>
						Volver <i class="fa fa-angle-right mx-1"></i>
						<a href="/">Inicio</a>
					</span>
				</div>
			</div>
		</section>

		<section class="section-page container-fluid">
			<div class="news container">
				<div class="row py-3">
					<div class="col-md-8">
						<div class="new-selected">
							<div class="title px-3">
								<h3>{{ ListaNoticia.Noticia.titulo }}</h3>
							</div>
							<div class="px-3">
								<div
								class="image w-100"
								:style="{
									'background-image': 'url(' + ListaNoticia.Noticia.imagen + ')'
								}"
							></div>
							</div>
							<div class="description px-3">
								<div class="text">
									<p class="date">
										<strong>Fecha de publicación:</strong>
										{{ ListaNoticia.Noticia.fecha }}
									</p>
									<hr>
									<div class="info" v-html="ListaNoticia.Noticia.descripcion"></div>
								</div>
							</div>
						</div>
					</div>
					<div class="col-md-4 p-0">
						<div class="section-right">
							<div class="title-right">
								<h3>ANTERIORES</h3>
							</div>
							<div class="search-right">
								<input type="text" ref="miInput" class="form-control" placeholder="Buscar noticia" />
								<button @click="searchNews">
									<i class="fa fa-search"></i>
								</button>
							</div>
							<div class="box">
								<div v-if="searchResults.Noticias.length > 0">
									<div v-for="(value, key) in searchResults.Noticias" :key="key" class="context">
										<a :href="'/noticias/' + value.id">
											<strong>{{ value.fecha }} - </strong>
											{{ value.titulo }}
										</a>
									</div>
								</div>
								<div v-else-if="searchQuery">
									<p class="text-white">No hay resultados</p>
								</div>
								<div v-else>
									<div v-for="(value, key) in ListaNoticia.Noticias.slice(0, 5)" :key="key" class="context">
										<a :href="'/noticias/' + value.id">
											<strong>{{ value.fecha }} - </strong>
											{{ value.titulo }}
										</a>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>
<script>
import { mapState, mapMutations } from 'vuex'

export default {
	name: 'noticias',
	computed: {
		...mapState(['empresa'])
	},
	created() {
		this.getVerificar()
	},
	data() {
		return {
            id: this.$route.params.id || '-',
			ListaNoticia: { Noticias: [] },
      searchQuery : '',
			searchResults: { Noticias: [] }
		}
	},
	watch: {
		'$route.params.id': function (newId) {
			this.id = newId
			if (!newId) {
				this.$router.push({ name: '404' })
			} else {
				this.getVerificar()
			}
		}
	},
	methods: {
		...mapMutations(['setLoading']),
		getVerificar() {
			this.setLoading(true)
			const endpoint = this.id !== '-' ? `ws_news/get_news?id=${this.id}` : 'ws_news/list_news'
			this.$http
				.get(endpoint)
				.then((res) => {
					this.ListaNoticia = res.data
				})
				.catch((error) => {
					console.error('Error fetching news:', error)
				})
				.finally(() => {
					this.setLoading(false)
				})
		},
		searchNews() {
      this.searchQuery =  this.$refs.miInput.value,
			this.setLoading(true)

			if (!this.searchQuery) {
				this.searchResults = { Noticias: [] }
				this.setLoading(false)
				return
			}

			this.$http
				.get(`ws_news/search_news?title=${this.searchQuery}`)
				.then((res) => {
					this.searchResults = res.data
				})
				.catch((error) => {
					console.error('Error searching news:', error)
					this.searchResults = { Noticias: [] }
				})
				.finally(() => {
					this.setLoading(false)
				})
		}
	}
}
</script>
